import {
  faMoneyBill,
  faChartPie,
  faGear,
  faMoneyBillTransfer,
  faBuildingColumns,
  faUsd,
  faUser,
  faUnlock
} from "@fortawesome/free-solid-svg-icons";
import { CustomRouter } from "../model/custom-router.model";
import { faCommentDots } from "@fortawesome/free-regular-svg-icons";

export const MENU: CustomRouter[] = [
  {
    to: "/",
    text: "Inicio",
    icon: faChartPie,
  },
  // {
  //     to: '/activity',
  //     text: 'Actividad',
  //     icon: faChartSimple
  // },
  {
    to: "/users",
    text: "Usuarios",
    icon: faUser,
  },

  {
    to: "/transactions",
    text: "Movimientos",
    icon: faMoneyBill,
  },
  {
    to: "/transferencias-bancarias",
    text: "Transferencias",
    icon: faBuildingColumns,
  },
  {
    to: "/contracargos",
    text: "Contracargos",
    icon: faMoneyBillTransfer,
  },

  {
    to: "/withdrawals",
    text: "Dispersiones",
    icon: faUsd,
  },
  {
    to: "/tarjetas",
    text: "Bloquear tarjetas",
    icon: faUnlock,
  },
  {
    to: "/developers",
    text: "Desarrolladores",
    icon: faGear,
  },
  // {
  //     text: 'Sign Out',
  //     icon: faRightFromBracket,
  //     click: handleLogout
  // }
];
